import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Lender.List.IRequest;
type Response = Api.Core.Lender.List.IResponse;
type Headers = Api.Core.Lender.List.IHeaders;
const url = '/api/Sales/Lender';
export default async function LenderListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
